export default {"src":"/_next/static/media/KeepaTypeFa.4af32ed6.svg","height":36,"width":55};